// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkComponent_link__3XgvH","icon":"LinkComponent_icon__2KXOu"};